module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f467-1f3fd.53069313.svg";